/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web1920148.css";

function Web1920148(props) {
  const { overlapGroup1, path14, path15, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-148 screen">
        <div className="overlap-group1-25" style={{ backgroundImage: `url(${overlapGroup1})` }}>
          <div className="rectangle-2-43 border-1px-dove-gray"></div>
          <img className="path-14-12" src={path14} />
          <img className="path-15-11" src={path15} />
          <div className="overlap-group-53">
            <div className="group-141-10">
              <div className="group-140-10">
                <div className="group-139-10">
                  <img className="group-138-10" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-13" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web1920148;
